import { get } from 'lodash';
import { mapState } from 'vuex';
import { bindCmsPluginAttrs } from 'util/vue/django-cms-spa';

export default {
    render() {
        if (this.showPartial) {
            return this.$scopedSlots.default(bindCmsPluginAttrs(this.partial));
        }

        return null;
    },
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapState('router', ['partials']),
        isPartialLoaded() {
            return !!this.partials[this.name];
        },
        isPartialAllowed() {
            return get(this.$route, 'meta.api.query.partials', []).includes(this.name);
        },
        showPartial() {
            return this.isPartialLoaded && this.isPartialAllowed;
        },
        partial() {
            return get(this.partials, `${ this.name }`, {});
        },
    },
};
